<fui-rows [formGroup]="editService.formGroup">
    <fui-row>
        <fui-four-columns>
            <fui-column>
                <wbo-single-select-edit-control [formControlName]="dateRangePeriodField" [label]="'wbo.report.edit.field.singleDatePeriod.label'"
                                                [placeholder]="'wbo.report.edit.field.singleDatePeriod.placeholder'"
                                                [(ngModel)]="model.data[dateRangePeriodField]"
                                                [allowClearSelectionOption]="false" [readonly]="disabled">
                    <wbo-select-options>
                        <wbo-select-option [value]="'Custom'"
                                           label="wbo.report.option.period.custom">
                        </wbo-select-option>
                        <wbo-select-option [value]="'Today'"
                                           label="wbo.report.option.period.today">
                        </wbo-select-option>
                        <wbo-select-option [value]="'Tomorrow'"
                                           label="wbo.report.option.period.tomorrow">
                        </wbo-select-option>
                        <wbo-select-option [value]="'Yesterday'"
                                           label="wbo.report.option.period.yesterday">
                        </wbo-select-option>
                        <wbo-select-option [value]="'Last Week'"
                                           label="wbo.report.option.period.last-week">
                        </wbo-select-option>
                        <wbo-select-option [value]="'This Week'"
                                           label="wbo.report.option.period.this-week">
                        </wbo-select-option>
                        <wbo-select-option [value]="'Last Month'"
                                           label="wbo.report.option.period.last-month">
                        </wbo-select-option>
                        <wbo-select-option [value]="'This Month'"
                                           label="wbo.report.option.period.this-month">
                        </wbo-select-option>
                        <wbo-select-option [value]="'This Year'"
                                           label="wbo.report.option.period.this-year">
                        </wbo-select-option>
                        <wbo-select-option [value]="'Last Year'"
                                           label="wbo.report.option.period.last-year">
                        </wbo-select-option>
                        <wbo-select-option [value]="'This Financial Quarter'"
                                           label="wbo.report.option.period.this-financial-quarter">
                        </wbo-select-option>
                        <wbo-select-option [value]="'Last Financial Quarter'"
                                           label="wbo.report.option.period.last-financial-quarter">
                        </wbo-select-option>
                        <wbo-select-option [value]="'This Financial Year'"
                                           label="wbo.report.option.period.this-financial-year">
                        </wbo-select-option>
                        <wbo-select-option [value]="'Last Financial Year'"
                                           label="wbo.report.option.period.last-financial-year">
                        </wbo-select-option>
                    </wbo-select-options>
                </wbo-single-select-edit-control>
            </fui-column>
            <fui-column>
                <wbo-date-edit-control [(ngModel)]="model.data[fromDateField]"
                                       [label]="'wbo.report.edit.field.singleDate.label'"
                                       [placeholder]="'wbo.report.edit.field.singletDate.placeholder'"
                                       [formControlName]="fromDateField"
                                       [readonly]="model.data[dateRangePeriodField] !== 'Custom' || disabled" [readonlyOnEdit]="model.data[dateRangePeriodField]!='Custom' || disabled"></wbo-date-edit-control>
            </fui-column>
        </fui-four-columns>
    </fui-row>
</fui-rows>
